import React from 'react';
import { motion } from 'framer-motion';
import { Translate } from 'i18n';

import { SNextButtonContainer, SSuccessText } from '../styled';
import GameFinishButton from '../../common/GameFinishButton';

interface IProps {
  onNextClick?: () => void;
}

const SuccessScreen: React.FC<IProps> = ({ onNextClick }) => {
  const nextClickHandler = () => {
    onNextClick && onNextClick();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <SNextButtonContainer>
        <SSuccessText>
          <Translate str="frontend.games.finished.go_to_next_exercise" />
        </SSuccessText>
        <GameFinishButton onClickAnimationComplete={nextClickHandler} />
      </SNextButtonContainer>
    </motion.div>
  );
};

export default SuccessScreen;
